import React from 'react'
import { css } from '@emotion/react'
import { connect } from 'react-redux'
import styled from '@emotion/styled'
import { compose } from 'redux'

import themeVars from 'ui_theme/site/globals/site.variables'
import { doSetFlag, selectIsFetchingFlags, selectFlag } from 'ducks/flags'
import { Button } from 'shared/ui'
import Sidebar from 'shared/components/ui/Sidebar'
import withOpenState from 'shared/ui/withOpenState'
import kbSearchBar from 'assets/kb-search-bar.png'

const flagName = 'has_seen_inbox_kb_search_update'

const ContentContainer = styled('div')`
  padding: ${props => props.theme.spacing['10']}
    ${props => props.theme.spacing['12']};
  font-family: ${themeVars.pageFont};
  font-size: ${props => props.theme.spacing['10']};
  line-height: ${props => props.theme.spacing['12']};

  img {
    max-width: 100%;
  }

  h4 {
    font-family: ${themeVars.walsheim};
    font-weight: ${themeVars.walsheimWeightBold};
    font-size: ${props => props.theme.spacing['11']};
  }

  p {
    margin: 0;
    margin-bottom: ${props => props.theme.spacing['10']};
    line-height: inherit;
  }

  li {
    line-height: inherit;
  }

  li + li {
    margin-top: ${props => props.theme.spacing['3']};
  }
`

class WithUpdateSidebar extends React.Component {
  handleNoticeClick = e => {
    const { flagHasSeen, onOpen } = this.props
    e.preventDefault()
    e.stopPropagation()
    onOpen()
    flagHasSeen()
  }

  render() {
    const { children, hasSeen, isFetchingFlags, onClose, open } = this.props

    return (
      <React.Fragment>
        <Sidebar
          headerChildren={'NEW – Knowledge Base search'}
          footerChildren={
            <Button size="large" fluid primary onClick={this.closeSidebar}>
              Got it!
            </Button>
          }
          onClose={onClose}
          open={open}
        >
          <ContentContainer>
            <div
              css={css`
                text-align: center;
              `}
            >
              <img
                alt={`KB search bar in ${app.t('Mailbox')}`}
                src={kbSearchBar}
                css={css`
                  width: 50%;
                `}
              />
            </div>
            <h4>Your knowledge base right in your {app.t('Mailbox')}</h4>
            <p>
              Supercharge your support workflow with our new Knowledge Base
              integration. Now you can link to and view KB articles without ever
              leaving the {app.t('Mailbox')}.
            </p>
            <p>
              <a
                href="https://help.groovehq.com/help/knowledge-base-integration-for-your-groove-inbox"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn how to use it here!
              </a>
            </p>
            <p>
              You told us how important it is to reduce friction and improve
              efficiency within the {app.t('mailbox')}. Our newest feature
              delivers on both accounts:
            </p>

            <ol>
              <li>
                <strong>
                  Effortlessly insert a Knowledge Base article directly into a
                  reply
                </strong>
              </li>
              <li>
                <strong>
                  Quickly open up a KB article from within the{' '}
                  {app.t('Mailbox')} for reference
                </strong>
              </li>
            </ol>
            <p>
              This Knowledge Base integration will help you save time, work more
              efficiently, and train new {app.t('agents')} with ease. It should
              also improve customer satisfaction and decrease response time.
            </p>
            <p>
              <em>It’s a win for all</em> 🙂🚀🎉
            </p>
          </ContentContainer>
        </Sidebar>

        {hasSeen || isFetchingFlags ? (
          children
        ) : (
          <div
            css={css`
              position: relative;
            `}
            onClick={this.handleNoticeClick}
          >
            {children}
          </div>
        )}
      </React.Fragment>
    )
  }
}

const select = state => {
  return {
    isFetchingFlags: selectIsFetchingFlags(state),
    hasSeen: selectFlag(state)(flagName),
  }
}

const perform = dispatch => {
  return {
    flagHasSeen: () => dispatch(doSetFlag(flagName)),
  }
}

export default compose(withOpenState, connect(select, perform))(
  WithUpdateSidebar
)
